import * as React from "react";
import Main from "./Main";
import { Empty } from "antd";
import Sidebar from "./Sidebar";
import styled from "styled-components";
import { FiUsers } from "react-icons/fi";
import Accordian from "../common/Accordian";
import { useDispatch, useSelector } from "react-redux";
import ChannelIcon from "../../assets/images/info-channel.svg";
import BrowserIcon from "../../assets/images/info-browser.svg";
import OsIcon from "../../assets/images/info-os.svg";
import LinuxIcon from "../../assets/images/ico-linux.svg";
import WindowsIcon from "../../assets/images/ico-windows.svg";
import DomainIcon from "../../assets/images/info-domain.svg";
import agentIcon from "../../assets/images/agent-icon.svg";
import botIcon from "../../assets/images/a8chat_icon.svg";
import { getGroups } from "../../actions/groupsAction";
import { toCustomDateTimeFormat } from "../../helpers/util";
import { getAgents } from "../../actions/agentsAction";

const WraperContainer = styled.div`
  display: flex;
  height: calc(100vh - 58px - 58px);
`;

export const SelectedChatHistoryMessageContext = React.createContext({
  selectedChat: "",
  setSelectedChat: (arg: any) => { },
});


const Container = styled.div`
  padding:  ${(props) => props.theme.clientConversation ? "0px" : "20px"};;
  white-space: nowrap;
  background-color: rgba(232, 233, 241, 0.5);
  transition: all 0.5s;
  transition-delay: ${(props) => props.theme.clientConversation ? "0s" : "0.5s"};
  @media screen and (min-width: 900px) and (max-width: 1400px) {    
    width: ${(props) => props.theme.clientConversation ? "0px" : "300px"};
  }
  @media screen and (min-width: 1400px){
    width: ${(props) => props.theme.clientConversation ? "0px" : "350px"};  
  }
`;

const Wrapper = styled.div`
  background: white;
  height: 100%;
  width: 100%;
  border-radius: 15px;
  box-shadow: 0 2px 6px 0 rgba(168, 171, 189, 0.3);
  border: solid 1px rgba(168, 171, 189, 0.3);
  overflow-x: hidden;
  overflow-y: auto;
`;

const ChatInfo = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  height: 82%;
  width: 98%;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  &::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
  }
`;

const NameWrapper = styled.div`
  padding: 20px 0 8px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
`;

const Name = styled.div`
  text-transform: capitalize;
  font-size: 18px;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  color: #212332;
`;

const IconicWraper = styled.div`
  display: flex;
  padding-left: 21px;
  font-size: 13px;
  font-weight: 600;
  color: #a8abbd;
  padding-top: 2px;
`;
const Iconic = styled.div`
  padding-left:10px;
  padding-top: 2px;
`;

const OnlineStatus = styled.div`
  width: 63px;
  height: 30px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  background-color: rgba(70, 178, 117, 0.2);
  color: #46b275;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LastSeenWrapper = styled.div`
  padding: 6px 0 10px 2px;
  font-size: 12px;
  color: #a8abbd;
  border-bottom: 1px solid rgba(168, 171, 189, 0.4);
  margin: 0 20px;
`;

const AccordianWrapper = styled.div`
  padding: 20px 20px 0;
  margin-bottom:1px;
`;

const ParticipantContainer = styled.p`
  display: flex;
  align-items: center;
`;

const UserId = styled.p`
  font-size: 14px;
  padding: 0px 0px 0px 20px;
  margin-bottom: 10px;
  height: 10px;
`;

const array2Objects = (array = [], field) => {
  return array.reduce((a, c) => {
    a[c[field]] = c;
    return a;
  }, {});
};

const Info = ({ chatData }) => {
  const { clientData, participants, groupId, lastTouched } = chatData;
  const [cusFields, setCusFields] = React.useState([]);
  const dispatch = useDispatch();
  const fetchGroups = React.useCallback(() => dispatch(getGroups()), [dispatch]);
  const fetchAgents = React.useCallback(() => dispatch(getAgents()), [dispatch]);
  const { primaryColor: highlightAgent, secondaryColor } = useSelector(
    (state: any) => state.ui.theme
  );
  const { group: groupReducer, agent: agentReducer } = useSelector((state: any) => state);
  const groups = array2Objects(groupReducer.groups, "_id");
  const agents = array2Objects(agentReducer.agents, "_id");
  const agentId = useSelector((state: any) => state.auth.info.agentId);

  React.useEffect(() => {
    if (!groupReducer.groups.length)
      fetchGroups();
    if (!agentReducer.agents.length)
      fetchAgents();
  }, []);

  React.useEffect(() => {
    setCusFields([]);
    if (clientData && clientData.userInfo && clientData.userInfo.customFields) {
      loopingObj(clientData.userInfo.customFields);
    }
  }, [clientData && clientData.userInfo && clientData.userInfo.customFields, secondaryColor]);

  const getOsIcon = () => {
    const { os } = clientData.deviceInfo;
    switch (os && os.toLowerCase()) {
      case "unix":
        return LinuxIcon;
      case "windows":
        return WindowsIcon;
      default:
        return OsIcon;
    }
  };

  const createCusField = (key, value) => {
    let isLink = new RegExp("^(http|https)://", "i");
    let newField = [];
    newField.push(<div style={{
      background: secondaryColor + "24",
      padding: "10px 10px",
      borderRadius: "10px",
      margin: "10px 0px"
    }}>
      <div style={{
        color: secondaryColor,
        fontWeight: 800,
        textTransform: "capitalize",
        textOverflow: "ellipsis",
        overflow: "hidden"
      }}>{key}</div>
      {isLink.test(value) ? <a target="_bank" style={{ wordBreak: "break-all", whiteSpace: "break-spaces", textDecoration: "underline" }} href={value}>{value}</a> : <div style={{ wordBreak: "break-all", whiteSpace: "break-spaces" }}>{value}</div>}
    </div>)
    setCusFields(cusFields => [...cusFields, ...newField])
  }

  const loopingObj = (customFields) => {
    for (let cf in customFields) {
      if (typeof customFields[cf] === "string" || typeof customFields[cf] === "number") {
        createCusField(cf, customFields[cf]);
      } else if (typeof customFields[cf] === "object") {
        loopingObj(customFields[cf])
      }
    }
  }

  return (
    <Container>
      <Wrapper>
        {clientData ? (
          <>
            <NameWrapper>
              <Name title={clientData.fromName}>{clientData.fromName}</Name>
              <OnlineStatus>Active</OnlineStatus>
            </NameWrapper>
            <UserId>{clientData.userInfo.userId}</UserId>
            <ChatInfo>
              {clientData.deviceInfo && (
                <>
                  <IconicWraper>
                    <img src={ChannelIcon} />
                    <Iconic>
                      <span className="img">{clientData && clientData.deviceInfo.channel}</span>
                    </Iconic>
                  </IconicWraper>
                  <IconicWraper>
                    <img src={BrowserIcon} />
                    <Iconic>
                      <span>{clientData && clientData.deviceInfo.browser && clientData.deviceInfo.browser.name}</span>
                    </Iconic>
                  </IconicWraper>
                  <IconicWraper>
                    <img src={getOsIcon()} />
                    <Iconic>
                      <span className="img">{clientData && clientData.deviceInfo.os}</span>
                    </Iconic>
                  </IconicWraper>
                  <IconicWraper><img src={DomainIcon} className="icon" alt="domain" />
                    <Iconic>
                      <a className="img" target="blank"
                        href={clientData.deviceInfo.browser && clientData.deviceInfo.browser.domain}> Show Origin</a>
                    </Iconic>
                  </IconicWraper>
                </>
              )}
              {lastTouched && <LastSeenWrapper>Last Seen: {toCustomDateTimeFormat(lastTouched)}</LastSeenWrapper>}
              <AccordianWrapper>
                <Accordian title="Participants">
                  {participants.map((item: any, index: number) => (
                    <ParticipantContainer key={index}>
                      {agents && agents[item] && <img width="24px" height="auto" src={agents[item].isVirtualAgent ? botIcon : agentIcon} alt="Participant Icon" />}
                      &nbsp;
                      <span style={{ fontWeight: agentId == item ? 900 : "inherit", color: agentId == item ? highlightAgent : "#000" }} >{item === agentId ? "You" : (agents && agents[item] && agents[item].name)}</span>
                    </ParticipantContainer>
                  ))}
                </Accordian>
              </AccordianWrapper>
              {groupId && (
                <AccordianWrapper>
                  <Accordian title="Group">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <FiUsers />
                      <div title={groups && groups[groupId] && groups[groupId].name} style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                        &nbsp;{groups && groups[groupId] && groups[groupId].name}
                      </div>
                    </div>
                  </Accordian>
                </AccordianWrapper>
              )}
              <AccordianWrapper>
                <Accordian title="Custom Fields">
                  <div>
                    {cusFields.length > 0 && cusFields || <div>No Details Available</div>}
                  </div>
                </Accordian>
              </AccordianWrapper>
            </ChatInfo>
          </>
        ) :
          <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "20px" }}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        }
      </Wrapper>
    </Container>
  );
}

export default function Overview() {
  const [selectedChat, setSelectedChat] = React.useState("");
  const [chatData, setChatData] = React.useState<any>([]);

  return (
    <WraperContainer>
      <SelectedChatHistoryMessageContext.Provider
        value={{ selectedChat, setSelectedChat }}
      >
        <Sidebar />
        <Main setChatData={setChatData} />
        <Info chatData={chatData} />
      </SelectedChatHistoryMessageContext.Provider>
    </WraperContainer>
  );
}
